var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square__container"},[_c('div',{staticClass:"square__content-container"},_vm._l((_vm.data),function(item,idx){return _c('SquareCompare',{key:`square-${idx}`,attrs:{"data":item,"max":_vm.max,"scenarioLabels":_vm.scenarios}})}),1),_c('div',[_vm._t("legend")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }